import { useAuth } from "../contexts/AuthContext";

/**
 * Groups: Accounting, Admin, Engineering, Field, Management,
 *         Purchasing, Sales, Shop, Subcontractor
 */
export function usePermissions() {
    const { user } = useAuth();
    const groups = user?.groups ?? [];

    return {
        /** True if the user belongs to every listed group. */
        hasAllGroups: (...required) =>
            required.every((g) => groups.includes(g)),

        /** True if the user belongs to at least one of the listed groups. */
        hasGroup: (...allowed) => allowed.some((g) => groups.includes(g)),

        isAdmin: groups.includes("Admin"),
        isAccounting: groups.includes("Accounting"),
        isEngineering: groups.includes("Engineering"),
        isField: groups.includes("Field"),
        isManagement: groups.includes("Management"),
        isPurchasing: groups.includes("Purchasing"),
        isSales: groups.includes("Sales"),
        isShop: groups.includes("Shop"),
        isSubcontractor: groups.includes("Subcontractor"),

        groups,
    };
}
